import React from 'react';

const SelfieCardViewer = ({ image }) => {
  return (
    <div>
      <div className="text-center SelfieCard my-24">
        <img
          src={image}
          alt=""
          style={{
            width: '200px',
            height: '250px',
            border: '1px solid #ccc',
            borderRadius: '8px',
            objectFit: 'cover',
            margin: '0 auto',
          }}
        />
      </div>
    </div>
  );
};

export default SelfieCardViewer;
